import React, { useEffect, useState } from 'react'
import CustomTable from '../../../../components/BasicUI/CustomTable'
import APP_ICONS from '../../../../config/constants/icons'
import { useDeleteQualification, useQualifications, useQualificationsFacet } from '../../../../config/query/qualificationQuery'
import { formatDateTime, formatDateTimeFromNow } from '../../../../config/helpers/dateHelper'
import { getFilters } from '../../../../config/helpers/filterHelper'
import LabelValuePair from '../../../../components/BasicUI/LabelValuePair'
import TableInfoPopover from '../../../../components/BasicUI/Popovers/TableInfoPopover'
import StatusBadge from '../../../../components/BasicUI/Badges/StatusBadge'
import Chronology from '../../../../components/BasicUI/DataBoxes/Chronology'
import { makeInitialQueryObject } from '../../../../config/helpers/queryHelper'
import { useNavigate } from 'react-router'

const QualificationList = ({ onEditModal }) => {

  const navigate = useNavigate()

  const [query, setQuery] = useState(
    makeInitialQueryObject({
      currentQuery: true, injectParams: {
        pageNo: 1,
        pageSize: 20,
      }
    })
  )

  const qualificationQuery = useQualifications(query)
  const qualificationFacetQuery = useQualificationsFacet()
  const deleteQualificationQuery = useDeleteQualification()

  const handleDelete = (id) => {
    deleteQualificationQuery.mutateAsync(id)
      .then((response) => {
        qualificationQuery.refetch()
        console.log(`Qualification deleted successfully: ${response}`)
      })
      .catch((error) => {
        console.log(`Error while deleting qualification: ${error}`)
      })
  }

  const handleQueryChange = (updatedQuery) => {
    setQuery(updatedQuery)
    navigate(`?${makeInitialQueryObject({
      injectParams: updatedQuery,
      prepareQueryString: true
    })}`)
  }

  return (
    <CustomTable
      containerProps={{ mt: 5 }}
      searchPlaceholder="Search qualifications"
      filters={getFilters(qualificationFacetQuery?.data)}
      head={[
        {
          title: "Name",
          extractor: "name",
          align: "left",
          isSortable: true,
          component: (item) => (
            <TableInfoPopover
              data={item}
              onEdit={(item) => onEditModal(item)}
              onDelete={(id) => handleDelete(id)}
              triggerOnClick={() => onEditModal(item)}
            >
              <LabelValuePair label="Description" value={item.description} />
              <LabelValuePair
                label="Status"
                value={true}
                valueComponent={
                  <StatusBadge value={item.status} />
                }
              />
              <LabelValuePair label="Created" value={formatDateTime(item.createdBy?.dateTime)} />
              <LabelValuePair label="Last Updated" value={formatDateTime(item.updateBy?.dateTime)} />
            </TableInfoPopover>
          )
        },
        {
          title: "Status",
          extractor: "status",
          isSortable: true,
          component: (item) => <StatusBadge value={item.status} />
        },
        {
          title: "Last Modified",
          extractor: "lastModified",
          component: (item) => <Chronology data={item} />
        },
        {
          title: "Actions",
          extractor: "actions"
        }
      ]}
      data={qualificationQuery?.data?.results?.map((item) => {
        return {
          ...item,
          lastModified: item.updatedBy ? formatDateTimeFromNow(item.updatedBy?.dateTime) : formatDateTimeFromNow(item.createdBy?.dateTime),
          actions: [
            {
              title: "Edit",
              action: () => onEditModal(item),
              icon: APP_ICONS.EDIT,
              isEdit: true
            },
            {
              title: "Delete",
              action: handleDelete,
              icon: APP_ICONS.BIN,
              isDelete: true
            }
          ]
        }
      })}
      loading={qualificationQuery?.isLoading}
      totalResults={qualificationQuery?.data?.totalResults}
      totalPages={qualificationQuery?.data?.totalPages}
      pageNo={query.pageNo}
      pageSize={query.pageSize}
      onQueryChange={(updatedQuery) => handleQueryChange({ ...query, ...updatedQuery })}
      query={query}
      onRefresh={() => qualificationQuery.refetch()}
      isRefreshing={qualificationQuery?.isFetching}
      sortBy={query?.sortBy}
      sortOrder={query?.sortOrder}
    />
  )
}

export default QualificationList

